import { ResponseHeader } from "./ResponseHeader"

export const ResponseFileName = (
  r: Request | Response | XMLHttpRequest,
  name: "file"
) => {
  // supports both fetch and xhttp

  const h = ResponseHeader(r, "content-disposition", "")

  try {
    return h.split("filename=")[1].split(";")[0]
  } catch {
    return name
  }
}
